// src/components/ShowSelect.jsx
// "Show" (how many rows to load), as on the fax lists: 50 by default (3.16.0)
export const SHOW_OPTIONS = ['50', '100', '200', '500', 'all'];

// options: another list of choices (e.g. Fax Retries: 10–50, 3.18.8)
export default function ShowSelect({ value, onChange, style, labelStyle, groupStyle, options = SHOW_OPTIONS }) {
  return (
    <div style={groupStyle}>
      <label style={labelStyle}>Show</label>
      <select value={value} onChange={e => onChange(e.target.value)} style={style} aria-label="How many to show">
        {options.map(v => <option key={v} value={v}>{v === 'all' ? 'All' : v}</option>)}
      </select>
    </div>
  );
}
